import Box from '@mui/material/Box';
import React from 'react';
import ContentsSlider from './ContentsSlider';
import { ItAppImageLinkCard } from './ItAppImageLinkCard';
import { mediaQuery, useMediaQuery } from '../hooks/useMediaQuery';

/** MyMine Version2.0 新規追加
 * MetadataItAppsSlider
 */
const MetadataItAppsSlider = (
  {
    controlSettings,
    screenId,
    selectedSlideMetadataList,
    setSelectedSlideMetadataList,
    callbackFavorite,
    metadataId,
    itAppList,
    setIsLoading,
  }) => {

  /**
   * ファイルスライド処理
   * @param {any} slideMetadataId
   * @param {any} slideCount
   */
  const onChangeSlide = (slideMetadataId, slideCount) => {
    selectedSlideMetadataList[slideMetadataId] = slideCount;
    setSelectedSlideMetadataList(selectedSlideMetadataList)
  }

  const isPcOriginal = useMediaQuery(mediaQuery.pc);
  const isWideScreen = useMediaQuery('(min-width:1025px)');
  const isSmallScreen = useMediaQuery('(max-width:375px)');
  const isPc = isPcOriginal && isWideScreen;

  // 一度に表示する項目数
  const slidesToShowCount = isPc ? 4 : 1;
  // 一度に表示する幅
  const contentBoxWidth = (itAppList.length >= 4 || itAppList.length === 1) ? 1152 : 290 * itAppList.length;
  const boxWidth = isPc ? contentBoxWidth + 'px' : (isSmallScreen ? '290px':'320px');

  return (
    <Box sx={{
      '.slick-slide': { textAlign: 'center' },
      width: boxWidth,
      margin:'0 auto'
    }} >
      <ContentsSlider
        initialSlide={selectedSlideMetadataList[metadataId] || 0}
        onChangeSlide={(slideCount) => onChangeSlide(metadataId, slideCount)}
        contentsCount={itAppList.length}
        slidesToShow={slidesToShowCount}
      >
        {itAppList.map((itApp, i) =>
          <Box key={i} sx={{ width: isSmallScreen ? '220px !important' : '250px !important', height: '290px' }}>
            {itApp && <ItAppImageLinkCard screenId={screenId} itApp={itApp} callbackFavorite={callbackFavorite } setIsLoading={setIsLoading} imageContainerHeight='180px' />}
          </Box>
        )}
      </ContentsSlider>

    </Box >
  );
}
export default MetadataItAppsSlider;